define('ShopByModel.Details.View', [
  'SCView',
  'shop_by_model_details.tpl'
], function (
  SCViewModule,
  gofer_model_details_tpl
) {
  'use strict';

  var SCView = SCViewModule.SCView;

  function GoferModelDetailsView(options) {
    SCView.call(this, options);

    this.model = options.model;

    this.template = gofer_model_details_tpl;
  }

  GoferModelDetailsView.prototype = Object.create(SCView.prototype);
  GoferModelDetailsView.prototype.constructor = GoferModelDetailsView;

  GoferModelDetailsView.prototype.getContext = function () {
    var url = 'gofer-parts/' + encodeURIComponent(this.model.get('name'));

    return {
      model: this.model,
      image: this.model.get('image'),
      name: this.model.get('name'),
      parentModel: this.model.get('parentModel'),
      type: this.model.get('type'),
      value: this.model.get('value'),
      url: url
    };
  };

  return GoferModelDetailsView;
});
